import React from "react"

const soundPing = "/sounds/ping.mp3"
const soundBeepBeep = "/sounds/beep-beep.mp3"

interface RevisionAudioProps {
  audioSuccessRef: React.RefObject<HTMLAudioElement>
  audioFailedRef: React.RefObject<HTMLAudioElement>
}

export default function RevisionAudio({
  audioSuccessRef,
  audioFailedRef,
}: RevisionAudioProps) {
  return (
    <React.Fragment>
      {/* Audio: Success added */}
      <audio className="hidden" ref={audioSuccessRef} src={soundPing} />

      {/* Audio: Failed, not added */}
      <audio className="hidden" ref={audioFailedRef} src={soundBeepBeep} />
    </React.Fragment>
  )
}
